const searchSuggestion = () =>{
    if (document.querySelector('.ume-lab-services-search-input')) {
        const inputField = document.querySelector('.ume-lab-services-search-input');
        const options = Object.values(JSON.parse(ume_lab_env.ume_lab_list));

        const select =  document.querySelector('.ume-lab-services-search-list');
        inputField.addEventListener('keyup', inputFieldDebounce(() => {

            select.innerHTML = '';
            select.classList.add('d-none');
            if (inputField.value.length >= 1) {
                let results = options.filter(element => element.includes(inputField.value) || element.toLowerCase().includes(inputField.value));

                if(results.length > 0){
                    results.forEach( r =>{
                        let item = document.createElement('li');
                        let option = document.createElement('button');
                        option.classList.add('btn');
                        option.classList.add('btn-link');
                        option.classList.add('ume-lab-services-search-list-button');
                        option.innerHTML = r;
                        option.setAttribute('data-target-search', r);
                        item.appendChild(option);
                        select.appendChild(item);
                    })
                    select.classList.remove('d-none');
                    document.addEventListener('click', ev =>{
                        select.classList.add('d-none');
                        if(!ev.target.classList.contains('ume-lab-services-search-list-button')){

                            return;
                        }

                        let button = ev.target;
                        let value = button.innerHTML;

                        inputField.value = value;
                        inputField.focus();

                    }, {
                        'once': true
                    })
                }

            }


        }, 800))


        document.addEventListener('search', ev =>{



            select.classList.add('d-none');


        })

        function inputFieldDebounce(callback, wait) {
            let timeout;
            return (...args) => {
                clearTimeout(timeout);
                timeout = setTimeout(function () {
                    callback.apply(this, args);
                }, wait);
            };
        }

    }
}
export default searchSuggestion;
